<template>
  <BModal
    :id="id"
    ref="modalOffTalent"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    :centered="true"
    content-class="border-0"
  >
    <div class="text-center flex flex-col gap-[1.5rem] p-[1rem]">
      <div class="flex flex-col gap-[.5rem]">
        <h4 class="font-semibold text-[1.25rem] text-[#222222] m-0">
          Eksekusi Off Talent?
        </h4>
        <p class="text-[#555555] m-0 text-base">
          Anda akan mengakhiri assignment talent pada partner ini.
        </p>
      </div>

      <div class="bg-[#F5F5F5] rounded-[0.75rem] p-[1rem] flex items-center gap-[.75rem] text-left">
        <div class="text-[#888888] shrink-0">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M12 16V12"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 8H12.01"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <p class="text-[#555555] m-0 text-sm">
          Setelah proses dikonfirmasi, tindakan ini tidak dapat dibatalkan.
        </p>
      </div>

      <div class="flex gap-[1rem]">
        <BButton
          variant="light"
          class="bg-[#F5F5F5] border-0 text-[#222222] font-semibold rounded-[0.75rem] hover:bg-[#EBEBEB] m-0"
          block
          @click="closeModal"
        >
          Batalkan
        </BButton>
        <BButton
          variant="primary"
          class="bg-[#F97316] border-0 font-semibold rounded-[0.75rem] hover:bg-[#EA580C] m-0"
          block
          @click="handleConfirm"
        >
          Ya, Off-kan Talent
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalOffTalent',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.id)
    },
    handleConfirm() {
      this.$emit('confirm')
      this.closeModal()
    },
  },
}
</script>

<style scoped>
::v-deep .modal-content {
  border-radius: 1rem !important;
}
::v-deep .modal-dialog {
  max-width: 500px;
}

.btn-primary,
.btn-light {
  border-radius: 10px !important;
}
</style>
